module.exports = __webpack_public_path__ + "images/canonical-card/description-icon.d490b4a6ff5f2799fac0.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/description-icon.svg
// module id = YuXc
// module chunks = 0